import { DiscountType } from "@omni/types/api/product/bff/shared/enums/discountType.enum";
import { PromotionType } from "@omni/types/api/product/bff/shared/enums/promotionType.enum";
import { Promotion } from "@omni/types/api/product/bff/shared/promotion.model";

import { ProductCashBackPromotion } from "@/components/Product/ECommerce/eCommerce.types";

const getDiscountType = (promotion: Promotion): DiscountType | null => {
    if (promotion?.promotionValue) return DiscountType.Absolute;
    if (promotion?.promotionPercent) return DiscountType.Percentage;

    return null;
};

const getCashbackPromotion = (
    promotions: Promotion[] = []
): ProductCashBackPromotion | null => {
    const cashbackPromotion = promotions.filter(
        (p) => p.promotionType === PromotionType.Cashback
    )[0];

    const cashbackUnit = getDiscountType(cashbackPromotion);
    const cashbackAmount =
        cashbackUnit === DiscountType.Absolute
            ? cashbackPromotion?.promotionValue
            : cashbackPromotion?.promotionPercent;

    return cashbackPromotion
        ? ({
              ...cashbackPromotion,
              cashbackUnit,
              cashbackAmount
          } as ProductCashBackPromotion)
        : null;
};

export { getCashbackPromotion };
